import { useFormMutation } from "@/hooks/useFormMutation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { APIError, ApiResponse, DataObject, DataPaginate } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { VisitorPayload } from "./validation";

const fetchIncomingLetterVisit = async (
  params?: string
): Promise<ApiResponse<DataPaginate<IncomingMailVisitResponse>>> => {
  return await fetcher(`incoming-letters/visitors?${params}`);
};

export const useGetIncomingLetterVisit = (params?: string) => {
  return useQuery<
    ApiResponse<DataPaginate<IncomingMailVisitResponse>>,
    APIError
  >({
    queryKey: ["useGetIncomingLetterVisit", params],
    queryFn: async () => {
      const response = await fetchIncomingLetterVisit(params);
      return response;
    },
  });
};

export const useGetIncomingLetterVisitDetail = (id: number) => {
  return useQuery<
    ApiResponse<DataObject<IncomingMailVisitDetailResponse>>,
    APIError
  >({
    queryKey: ["useGetIncomingLetterVisitDetail", id],
    queryFn: async () => {
      const response = await fetcher(`incoming-letters/visitors/${id}`);
      return response;
    },
    enabled: !!id,
  });
};

export const useIncomingLetterVisitMutation = () => {
  return useFormMutation<
    ApiResponse<DataObject<VisitorPayload>>,
    APIError,
    VisitorPayload
  >({
    mutationFn: async (payload) => {
      return await sendData(`landing-forms/visitor`, payload, "POST", true);
    },
    successMessage: `Berhasil Surat Kunjungan`,
  });
};
